class ProfessionalsSlider extends HTMLElement {
  #items = [];
  #dots = [];
  #observer = null;

  connectedCallback() {
    this.#items = Array.from(this.querySelectorAll('.professional-item'));
    this.#dots = Array.from(this.querySelectorAll('.professionals-slider__dot'));

    if (this.#items.length === 0 || this.#dots.length === 0) return;

    this.#observer = new IntersectionObserver(
      (entries) => this.#onIntersect(entries),
      {
        root: this.querySelector('.professionals__list'),
        threshold: 0.5,
      }
    );

    this.#items.forEach((item) => this.#observer.observe(item));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #onIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const index = this.#items.indexOf(entry.target);
      if (index === -1) return;
      this.#setActiveIndex(index);
    });
  }

  #setActiveIndex(index) {
    this.#dots.forEach((dot, i) => {
      dot.classList.toggle('professionals-slider__dot--active', i === index);
    });
  }
}

customElements.define('professionals-slider', ProfessionalsSlider);
